import { useState } from "react";

export function useTwist() {
  const [internalTwistActive, setInternalTwistActive] = useState(false);
  
  const activateTwist = () => {
    setInternalTwistActive(true);
  };
  
  const resetTwist = () => {
    setInternalTwistActive(false);
  };
  
  return {
    twistActive: false,
    activateTwist,
    resetTwist
  };
}
